<template>
  <div>
    <Modal
      v-model="addEditModal"
      :title="
        !accountForm.id
          ? this.$t('permission_configuration_management.account.addAccount')
          : this.$t('permission_configuration_management.account.editAccount')
      "
      :loading="loading"
      @on-ok="submit('accountForm')"
      :okText="
        !accountForm.id
          ? this.$t('alarms.common.add')
          : this.$t('permission_configuration_management.account.confirm')
      "
      :cancelText="$t('alarms.common.cancel')"
      @on-cancel="cancel('accountForm')"
      :mask-closable="false"
      width="900"
      :styles="{ top: '80px' }"
    >
      <Form
        ref="accountForm"
        :model="accountForm"
        :label-width="100"
        :rules="ruleValidate"
      >
        <div
          v-show="
            accountForm.accountType == '0' &&
              accountForm.authenticationType == '3'
          "
          style="margin-left: 30px"
        >
          <Alert type="warning" show-icon>
            {{ $t("alarms.common.warning") }}
            <template slot="desc">{{ $t("message.tips") }}</template>
          </Alert>
        </div>
        <Row>
          <Col span="12">
            <!-- 公司 -->
            <FormItem
              :label="$t('permission_configuration_management.account.company')"
              prop="companyId"
              v-if="!accountForm.id && company == 1"
            >
              <Select
                v-model="companyId"
                style="width: 300px"
                filterable
                placeholder=""
              >
                <Option
                  :value="item.id"
                  v-for="(item, index) in companyList"
                  v-bind:key="index"
                >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
            <div v-else>
              <FormItem
                :label="
                  $t('permission_configuration_management.account.company')
                "
              >{{ this.companyName }}</FormItem
              >
            </div>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <!-- 账户类型 -->
            <FormItem
              :label="
                $t('permission_configuration_management.account.accountType')
              "
              prop="accountType"
            >
              <Select
                v-model="accountForm.accountType"
                style="width: 300px"
                @on-change="accountTypeChange(accountForm.accountType)"
                placeholder=""
                filterable
              >
                <Option
                  :value="item.id"
                  v-for="item in accountTypeList"
                  :key="item.id"
                >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <!-- 账户名 -->
            <FormItem
              :label="
                $t('permission_configuration_management.account.accountName')
              "
              prop="name"
            >
              <Input
                v-model="accountForm.name"
                placeholder=""
                style="width: 300px"
              ></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <!-- 账户ID -->
            <FormItem
              :label="
                $t('permission_configuration_management.account.accountId')
              "
              prop="accountId"
              v-if="!accountForm.id"
            >
              <Input
                v-model="accountForm.accountId"
                style="width: 300px"
              ></Input>
            </FormItem>
            <div v-else>
              <FormItem
                :label="
                  $t('permission_configuration_management.account.accountId')
                "
              >{{ this.accountForm.accountId }}</FormItem
              >
            </div>
          </Col>
        </Row>
        <div v-if="accountForm.accountType == 2">
          <Row>
            <Col span="12">
              <!-- 订阅ID -->
              <FormItem
                :label="
                    $t(
                      'permission_configuration_management.account.subscriptionId'
                    )
                  "
                prop="subscriptionId"
                :key="4"
              >
                <Input
                  v-model="accountForm.subscriptionId"
                  placeholder=""
                  style="width: 300px"
                ></Input>
              </FormItem>
            </Col>
            <Col span="12">
              <!-- 订阅名称 -->
              <FormItem
                :label="
                    $t(
                      'permission_configuration_management.account.subscriptionName'
                    )
                  "
                prop="subscriptionName"
                :key="5"
              >
                <Input
                  v-model="accountForm.subscriptionName"
                  placeholder=""
                  style="width: 300px"
                ></Input>
              </FormItem>
            </Col>
          </Row>
        </div>
        <Row v-if="accountForm.accountType == 4">
          <Col span="12">
            <!-- projectId -->
            <FormItem label="Project ID" prop="projectId" :key="1">
              <Input
                v-model="accountForm.projectId"
                style="width: 300px"
              ></Input>
            </FormItem>
          </Col>
        </Row>
        <div>
          <Row>
            <Col span="12" v-if="accountForm.accountType != 4">
              <!-- 地区 -->
              <FormItem
                :label="$t('permission_configuration_management.account.area')"
                prop="areaType"
              >
                <RadioGroup
                  v-model="accountForm.areaType"
                  @on-change="changeAreaType()"
                >
                  <Radio
                    v-for="list in areaTypeList"
                    :label="list.areaType"
                    :key="list.value"
                  >{{ list.label }}</Radio
                  >
                </RadioGroup>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <!-- 扫描区域 -->
              <FormItem
                :label="
                  $t('permission_configuration_management.account.region')
                "
                prop="regions"
              >
                <div class="addPolicies-main">
                  <CheckboxGroup
                    v-model="accountForm.regions"
                    v-if="
                      accountForm.accountType == 0 ||
                        accountForm.accountType == 1
                    "
                  >
                    <Checkbox
                      v-for="item in regionList"
                      :key="item.key"
                      :label="item.key"
                    >{{ item.name }}</Checkbox
                    >
                  </CheckboxGroup>
                  <CheckboxGroup v-model="accountForm.regions" v-else>
                    <Checkbox
                      v-for="item in regionList"
                      :key="item.key"
                      :label="item.key"
                    >{{ item.name }}</Checkbox
                    >
                  </CheckboxGroup>
                </div>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <!-- 认证方式 -->
              <FormItem
                :label="
                  $t('permission_configuration_management.account.authType')
                "
                prop="authenticationType"
                v-if="isShowAuthenticationType"
              >
                <Select
                  v-model="accountForm.authenticationType"
                  style="width: 300px"
                >
                  <Option
                    :value="item.id"
                    v-for="item in authenticationList"
                    :key="item.id"
                  >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <!--            <Col span="12">-->
            <!--              &lt;!&ndash; 监控数据源 &ndash;&gt;-->
            <!--              <FormItem-->
            <!--                :label="-->
            <!--                  $t('permission_configuration_management.account.dataSource')-->
            <!--                "-->
            <!--                prop="sourceData"-->
            <!--              >-->
            <!--                <Select v-model="accountForm.sourceData" style="width: 300px">-->
            <!--                  <Option-->
            <!--                    :value="item.sourceData"-->
            <!--                    v-for="item in sourceDataList"-->
            <!--                    v-bind:key="item.id"-->
            <!--                    >{{ item.name }}</Option-->
            <!--                  >-->
            <!--                </Select>-->
            <!--              </FormItem>-->
            <!--            </Col>-->
            <Col span="12">
              <!-- 扫描资源 -->
              <FormItem
                :label="
                  $t(
                    'permission_configuration_management.account.scanResources'
                  )
                "
                prop="scanResources"
                v-if="!accountForm.id"
              >
                <Select
                  v-model="accountForm.scanResources"
                  style="width: 300px"
                  placeholder=""
                >
                  <Option
                    :value="item.scanResources"
                    v-for="(item, index) in scanResourcesList"
                    :key="index"
                  >{{ item.scanResourcesName }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
          </Row>

          <!---       assume role       -->
          <div v-if="accountForm.authenticationType == 2">
            <!-- 角色会话名称 -->
            <FormItem
              :label="
                $t(
                  'permission_configuration_management.account.roleSessionName'
                )
              "
              prop="roleSessionName"
            >
              <Input
                v-model="accountForm.roleSessionName"
                placeholder=""
                style="width: 300px"
              ></Input>
            </FormItem>

            <Row>
              <Col span="12">
                <!-- 角色ARN -->
                <FormItem
                  :label="
                    $t('permission_configuration_management.account.roleArn')
                  "
                  prop="roleArn"
                >
                  <Input
                    v-model="accountForm.roleArn"
                    placeholder=""
                    style="width: 300px"
                  ></Input>
                </FormItem>
              </Col>
              <Col span="12">
                <!-- 外部ID -->
                <FormItem
                  :label="
                    $t('permission_configuration_management.account.externalId')
                  "
                  prop="externalId"
                >
                  <Input
                    v-model="accountForm.externalId"
                    placeholder=""
                    style="width: 300px"
                  ></Input>
                </FormItem>
              </Col>
            </Row>
          </div>

          <!---       分隔符       -->
          <div
            v-else-if="accountForm.accountType != 4"
          >
            <Row>
              <Col span="12">
                <!-- 访问密钥ID -->
                <FormItem
                  :label="
                    $t(
                      'permission_configuration_management.account.accessKeyID'
                    )
                  "
                  prop="accessKeyID"
                  :key="2"
                >
                  <Input
                    v-model="accountForm.accessKeyID"
                    placeholder=""
                    style="width: 300px"
                  ></Input>
                </FormItem>
              </Col>
              <Col span="12">
                <!-- 访问密钥KEY -->
                <FormItem
                  :label="
                    $t(
                      'permission_configuration_management.account.secretAccessKey'
                    )
                  "
                  prop="secretAccessKey"
                  :key="3"
                >
                  <Input
                    v-model="accountForm.secretAccessKey"
                    placeholder=""
                    style="width: 300px"
                  ></Input>
                </FormItem>
              </Col>
            </Row>
          </div>

          <!---       分隔符       -->

          <!-- 密钥文件 -->
          <div v-if="accountForm.accountType == 4">
            <FormItem
              :label="$t('LabelConfig.LabelSynchronization.Keys')"
              prop="enclosure"
            >
              <Upload
                ref="upload"
                :on-success="uploadSuccess"
                :on-error="uploadError"
                :accept="Accept"
                :headers="{ userName: userName }"
                multiple
                type="drag"
                :action="actionUrl"
                style="width: 96%"
                :show-upload-list="true"
                :on-remove="handleRemove"
              >
                <div>
                  <Icon
                    type="ios-cloud-upload"
                    size="50"
                    style="color: #3399ff"
                  ></Icon>
                  <p>{{ $t("message.uploadFile") }}</p>
                </div>
              </Upload>
            </FormItem>
          </div>
        </div>
      </Form>
    </Modal>
  </div>
</template>
<script>
import TableAccounts from "../account/TableAccounts.vue";
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
import rsa from "../../../../utils/rsa";
import aes from "../../../../utils/aes";
import {
  CLOUD_PLATFORM_ID,
  isAkSkPlatform
} from "../../../../utils/cloudPlatform.js";
let tableAccounts = TableAccounts;
export default {
  name: "AddOrUpdateAccount",
  data() {
    //密钥ID和密钥Key是否重复
    let validateAccessKeyID = (rule, value, callback) => {
      if (this.accountForm.secretAccessKey) {
        this.$refs.accountForm.validateField("secretAccessKey");
      }
      callback();
    };
    let validateSecretAccessKey = (rule, value, callback) => {
      if (this.accountForm.accessKeyID) {
        if (this.accountForm.regions.length <= 0) {
          callback(new Error(this.$t('RAM.common.PleaseSelectRegion')))
        } else {
          this.$api.account
            .validCredential({
              type: this.accountForm.accountType,
              areaType: this.accountForm.areaType,
              accessKeyId: this.accountForm.accessKeyID,
              secretAccessKey: this.accountForm.secretAccessKey,
              projectId: this.resolveProjectId(),
              regions: this.accountForm.regions,
              authenticationType: this.accountForm.accountType == 2 ? 3 : this.accountForm.authenticationType
            })
            .then(res => {
              if (res.status == 200) {
                callback();
              }
            })
            .catch(err => {
              if (err.status == 400) {
                callback(
                  new Error(this.$t("permission_configuration_management.account.accessKeyIdSecretInvalid"))
                );
              }
            });
        }
      } else {
        callback();
      }
    };
    // 验证外部id
    let validateExternalId = (rule, value, callback) => {
      if (this.accountForm.regions.length <= 0) {
        callback(
          new Error(this.$t('RAM.common.PleaseSelectRegion'))
        );
      } else {
        this.$api.account
          .validCredential({
            type: this.accountForm.accountType,
            areaType: this.accountForm.areaType,
            regions: this.accountForm.regions,
            authenticationType: this.accountForm.accountType == 2 ? 3 : this.accountForm.authenticationType,
            roleSessionName: this.accountForm.roleSessionName,
            roleArn: this.accountForm.roleArn,
            externalId: this.accountForm.externalId
          })
          .then(res => {
            if (res.status == 200) {
              callback();
            }
          })
          .catch(err => {
            callback(
              new Error(err.data.message)
            );
          });
      }
    };
    // 账户名称是否重复
    let validAccountNameCheck = (rule, value, callback) => {
      let data = {}
      if (this.accountForm.id) {
        data = {
          companyId: this.companyId,
          accountName: this.accountForm.name.trim(),
          id: this.accountForm.id
        }
      } else {
        data = {
          companyId: this.companyId,
          accountName: this.accountForm.name.trim()
        }
      }
      this.$api.account.accountNameCheck(data).then(res => {
        if (res.status == 200) {
          callback();
        }
      }).catch(err => {
        if (err.status == 400) {
          callback(new Error(this.$t('permission_configuration_management.account.accountNameDuplicate')));
        }
      });
    };

    let validAccountIdCheck = (rule, value, callback) => {
      if ((this.accountForm.accountType === 2 && this.accountForm.subscriptionId === '') || (this.accountForm.accountType === 4 && this.accountForm.projectId === '')) {
        return callback();
      }
      if (this.accountForm.accountId.trim() === '') {
        return callback();
      }
      let data = {
        companyId: this.companyId,
        cloudPlatformType: this.accountForm.accountType,
        accountId: this.accountForm.accountId.trim()
      }
      if (this.accountForm.accountType === 2) {
        data = {
          companyId: this.companyId,
          cloudPlatformType: this.accountForm.accountType,
          accountId: this.accountForm.accountId.trim(),
          subscriptionId: this.accountForm.subscriptionId
        }
      }
      if (this.accountForm.accountType === 4) {
        data = {
          companyId: this.companyId,
          cloudPlatformType: this.accountForm.accountType,
          accountId: this.accountForm.accountId.trim(),
          projectId: this.accountForm.projectId
        }
      }
      if (this.accountForm.id) {
        data.id = this.accountForm.id
      }
      this.$api.account
        .accountRepeatAddCheck(data)
        .then((res) => {
          if (res.status == 200) {
            callback();
          }
        }).catch(err => {
        if (err.status == 400) {
          callback(new Error(this.$t('permission_configuration_management.account.accountIdDuplicate')));
        }
      });
    };

    return {
      errorTip: false,
      companyName: "",
      userName: getCookie(global.cookieName),
      actionUrl: "",
      fileName: "",
      fileList: [],
      Accept: ".json", //上传文件格式限制
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      show: false,
      isShowAuthenticationType: false,
      accountForm: {
        id: "",
        name: "",
        accountId: "",
        areaType: "1",
        projectId: "",
        scanResources: "",
        regions: [],
        authenticationType: 3,
        // sourceData: "0",
        accessKeyID: "",
        secretAccessKey: "",
        roleArn: "",
        externalId: "",
        roleSessionName: "",
        accountType: 0,
        subscriptionId: "",
        subscriptionName: ""
      },
      regionList: [],
      scanResourcesList: [
        {
          scanResources: 1,
          scanResourcesName: this.$t(
            "permission_configuration_management.account.enable"
          )
        },
        {
          scanResources: 0,
          scanResourcesName: this.$t(
            "permission_configuration_management.account.disable"
          )
        }
      ],
      loading: true,
      areaTypeList: [
        {
          label: this.$t("RIAccountGroupManagement.China"),
          value: "china",
          areaType: "1"
        },
        {
          label: this.$t("RIAccountGroupManagement.Overseas"),
          value: "Overseas",
          areaType: "2"
        }
      ],
      authenticationList: [],
      accountTypeList: [],
      // sourceDataList: [
      //   {
      //     id: 0,
      //     name: this.$t("RIAccountGroupManagement.Native"),
      //     sourceData: "0"
      //   },
      //   {
      //     id: 1,
      //     name: "ELK",
      //     sourceData: "1"
      //   }
      // ],
      addEditModal: false,
      ruleValidate: {
        name: [
          { required: true, message: this.$t("permission_configuration_management.account.accountNameRequired"), trigger: "blur" },
          {
            type: "string",
            message: this.$t("permission_configuration_management.account.accountNameLength"),
            pattern: "^.{2,20}$",
            trigger: "blur"
          },
          { validator: validAccountNameCheck, trigger: "blur" }
        ],
        authenticationType: [
          { required: true, type: 'number', message: this.$t("permission_configuration_management.account.pleaseSelectAuthType"), trigger: "change" }
        ],
        // sourceData: [
        //   { required: true, message: "请选择数据源", trigger: "change" }
        // ],
        accountType: [
          { required: true, type: 'number', message: this.$t("permission_configuration_management.account.pleaseSelectAccountType"), trigger: "change" }
        ],
        areaType: [
          { required: true, message: this.$t("permission_configuration_management.account.pleaseSelectRegion"), trigger: "change" }
        ],
        projectId: [
          { required: true, message: this.$t("permission_configuration_management.account.pleaseInputProjectId"), trigger: "blur" },
          { validator: validAccountIdCheck, trigger: "blur" }
        ],
        accessKeyID: [
          { required: true, message: this.$t("permission_configuration_management.account.accessKeyIdRequired"), trigger: "blur" },
          { validator: validateAccessKeyID, trigger: "blur" }
        ],
        secretAccessKey: [
          { required: true, message: this.$t("permission_configuration_management.account.secretAccessKeyRequired"), trigger: "blur" },
          { validator: validateSecretAccessKey, trigger: "blur" }
        ],
        roleSessionName: [
          {
            required: true,
            message: this.$t("permission_configuration_management.account.roleSessionNameRequired"),
            trigger: "blur"
          },
          {
            type: "string",
            message: this.$t("permission_configuration_management.account.max100NonChinese"),
            pattern: "^[^\u4e00-\u9fa5]{0,100}$",
            trigger: "blur"
          }
        ],
        roleArn: [
          { required: true, message: this.$t("permission_configuration_management.account.roleArnRequired"), trigger: "blur" },
          {
            type: "string",
            message: this.$t("permission_configuration_management.account.max100NonChinese"),
            pattern: "^[^\u4e00-\u9fa5]{0,100}$",
            trigger: "blur"
          }
        ],
        externalId: [
          { required: true, message: this.$t("permission_configuration_management.account.externalIdRequired"), trigger: "blur" },
          {
            type: "string",
            message: this.$t("permission_configuration_management.account.max100NonChinese"),
            pattern: "^[^\u4e00-\u9fa5]{0,100}$",
            trigger: "blur"
          },
          { validator: validateExternalId, trigger: "blur" }
        ],
        subscriptionId: [
          { required: true, message: this.$t("permission_configuration_management.account.subscriptionIdRequired"), trigger: "blur" },
          {
            type: "string",
            message: this.$t("permission_configuration_management.account.max100NonChinese"),
            pattern: "^[^\u4e00-\u9fa5]{0,100}$",
            trigger: "blur"
          },
          { validator: validAccountIdCheck, trigger: "blur" }
        ],
        accountId: [
          { required: true, message: this.$t("permission_configuration_management.account.pleaseInputAccountId"), trigger: "blur" },
          {
            message: this.$t("permission_configuration_management.account.accountIdLength"),
            pattern: "^.{4,70}$",
            trigger: "blur"
          },
          { validator: validAccountIdCheck, trigger: "blur" }
        ],
        regions: [
          {
            required: true,
            type: "array",
            min: 1,
            message: this.$t("permission_configuration_management.account.atLeastOne"),
            trigger: "change"
          }
        ],
        scanResources: [
          {
            required: true,
            message: this.$t("permission_configuration_management.account.pleaseSelectScanResource"),
            trigger: "change",
            type: "number"
          }
        ]
      }
    };
  },
  mounted() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
    this.$api.account.queryCloudList().then(res => {
      this.accountTypeList = res.data;
    })
    // 上传附件接口
    this.actionUrl = process.env.API_ROOT + "/sme/account/uploadSecretFile";
  },
  methods: {
    // projectId 仅 GCP 使用密钥文件时需要，其余平台（含华为云、腾讯云）一律提交空值
    resolveProjectId() {
      const platformsWithoutProjectId = [
        CLOUD_PLATFORM_ID.HWC,
        CLOUD_PLATFORM_ID.TENCENT
      ];
      return platformsWithoutProjectId.indexOf(Number(this.accountForm.accountType)) !== -1
        ? ""
        : this.accountForm.projectId;
    },
    /*********************************  添加&编辑  ************************************/
    init(id, row) {
      this.accountForm.id = id || 0;
      this.addEditModal = true;
      this.$nextTick(() => {
        // 重置表单
        this.$refs["accountForm"].resetFields();
        // 编辑
        if (this.accountForm.id) {
          //id
          this.accountForm.id = id;
          // 公司
          this.companyName = row.companyName;
          this.companyId = row.companyId;
          // 账户名
          this.accountForm.name = row.name;
          // 账户ID
          this.accountForm.accountId = row.accountId;
          // 账户类型
          /****************************/
          this.accountForm.accountType = row.type;
          // projectID
          this.accountForm.projectId = this.accountForm.accountType == 4 ? row.projectId : "";
          if (row.type === 2) {
            this.isShowAuthenticationType = false;
          } else {
            this.isShowAuthenticationType = true;
            this.getAuthenticationList();
          }
          /**********地区******************/
          if (row.areaType == 1) {
            // 中国
            this.accountForm.areaType = "1";
          } else if (row.areaType == 2) {
            // 海外
            this.accountForm.areaType = "2";
          }
          /**********区域******************/
          this.$api.account
            .queryRegionsByAccount({
              type: row.type,
              areaType: row.areaType
            })
            .then(res => {
              this.regionList = res.data;
              this.accountForm.regions = row.regions;
            });
          // 认证方式
          /***************************************************************/
          this.accountForm.authenticationType = row.authenticationTypeId;
          // 数据源
          // if (row.sourceData == 0) {
          //   this.accountForm.sourceData = "0";
          // } else if (row.sourceData == 1) {
          //   this.accountForm.sourceData = "1";
          // }
          // 访问密钥ID
          this.accountForm.accessKeyID = row.accessKeyId;
          // 访问密钥Key
          this.accountForm.secretAccessKey = row.secretAccessKey;
          // 角色会话名称
          this.accountForm.roleSessionName = row.roleSessionName;
          // 角色ARN
          this.accountForm.roleArn = row.roleArn;
          // 外部ID
          this.accountForm.externalId = row.externalId;
          // 订阅ID
          this.accountForm.subscriptionId = row.subscriptionId;
          // 订阅名称
          this.accountForm.subscriptionName = row.subscriptionName;
        } else {
          if (this.accountForm.accountType === 2) {
            this.isShowAuthenticationType = false;
          } else {
            this.isShowAuthenticationType = true;
            this.getAuthenticationList();
          }
          this.queryRegionsByAccount();
        }
      });
    },
    // 获取公司下拉框
    getCompanyDropDownBox() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    },
    // 账户类型
    accountTypeChange(accountType) {
      this.accountForm.regions = [];
      this.accountForm.accountType = accountType;
      if (this.accountForm.accountType == 2) {
        this.isShowAuthenticationType = false;
      } else {
        this.isShowAuthenticationType = true;
        this.getAuthenticationList();
      }
      this.queryRegionsByAccount();
    },
    // 认证方式
    getAuthenticationList() {
      this.$api.account.queryAuthenticationType(this.accountForm.accountType).then(res => {
        this.authenticationList = res.data;
      })
    },
    // 扫描区域
    changeAreaType() {
      this.accountForm.regions = [];
      this.queryRegionsByAccount();
    },
    queryRegionsByAccount() {
      this.$api.account
        .queryRegionsByAccount({
          type:
            this.accountForm.accountType == 4
              ? "4"
              : this.accountForm.accountType,
          areaType:
            this.accountForm.accountType == 4 ? "2" : this.accountForm.areaType
        })
        .then(res => {
          this.regionList = res.data;
        });
    },
    // 附件
    /****************************************************/
    // 上传成功
    uploadSuccess(res, file, fileList) {
      this.fileList = fileList;
      this.fileName = file.response;
      if (process.env.TRANSFER_ENCRYPTION == "true") {
        //解密aes Key
        var key = rsa.decrypt(file.response.encrypted);
        //解密返回数据
        this.fileName = eval(
          "(" + aes.decrypt(file.response.requestData, key) + ")"
        );
      }
      this.$api.account
        .validCredential({
          type: this.accountForm.accountType,
          projectId: this.resolveProjectId(),
          regions: this.accountForm.regions,
          authenticationType: this.accountForm.authenticationType,
          secretFileName: this.fileName
        })
        .then(() => {
          this.$Message.success(this.$t("common.uploadSuccess"));
        })
        .catch(() => {
          this.$Message.error(this.$t("common.uploadFail"));
          this.fileList = [];
          this.fileName = "";
          this.$refs.upload.clearFiles()
        });
    },
    // 上传失败
    uploadError(error, file) {
      this.$Message.error(this.$t("common.uploadFail"));
    },
    // 删除附件
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.$api.account
        .deleteSecretFile("fileName", file.response)
        .then(res => {
          this.$Message.success(this.$t("common.deleteSuccess"));
        });
    },
    // 确定
    submit(name) {
      this.loading = true;
      this.$refs[name].validate(valid => {
        if (valid) {
          let accountDate = {
            companyId: this.companyId,
            name: this.accountForm.name,
            type: this.accountForm.accountType,
            accountId: this.accountForm.accountId.trim(),
            areaType: this.accountForm.areaType,
            projectId: this.resolveProjectId(),
            isScanResources: this.accountForm.scanResources,
            sourceData: "0",
            regions: this.accountForm.regions,
            authenticationType: this.accountForm.accountType == 2 ? 3 : this.accountForm.authenticationType
          };
          if (isAkSkPlatform(this.accountForm.accountType)) {
            accountDate.accessKeyId = this.accountForm.accessKeyID;
            accountDate.secretAccessKey = this.accountForm.secretAccessKey;
          } else {
            accountDate.accessKeyId = "";
            accountDate.secretAccessKey = "";
          }
          if (this.accountForm.authenticationType == 2) {
            accountDate.roleArn = this.accountForm.roleArn;
            accountDate.externalId = this.accountForm.externalId;
            accountDate.roleSessionName = this.accountForm.roleSessionName;
            accountDate.subscriptionId = "";
            accountDate.subscriptionName = "";
            accountDate.projectId = "";
            accountDate.secretFileName = "";
          } else if (this.accountForm.authenticationType == 3) {
            accountDate.subscriptionId = "";
            accountDate.subscriptionName = "";
            accountDate.projectId = "";
            accountDate.secretFileName = "";
            accountDate.roleArn = "";
            accountDate.externalId = "";
            accountDate.roleSessionName = "";
          }

          if (this.accountForm.accountType == 1) {
            accountDate.roleArn = "";
            accountDate.externalId = "";
            accountDate.roleSessionName = "";
            accountDate.subscriptionId = "";
            accountDate.subscriptionName = "";
            accountDate.projectId = "";
            accountDate.secretFileName = "";
          } else if (this.accountForm.accountType == 2) {
            accountDate.subscriptionId = this.accountForm.subscriptionId;
            accountDate.subscriptionName = this.accountForm.subscriptionName;
            accountDate.roleArn = "";
            accountDate.externalId = "";
            accountDate.roleSessionName = "";
            accountDate.projectId = "";
            accountDate.secretFileName = "";
            // } else if (this.accountForm.accountType == 3) {
            //   accountDate.areaType = "";
            //   accountDate.isScanResources = 0;
            //   accountDate.sourceData = "1";
            //   accountDate.roleArn = "";
            //   accountDate.externalId = "";
            //   accountDate.roleSessionName = "";
            //   accountDate.subscriptionId = "";
            //   accountDate.subscriptionName = "";
            //   accountDate.projectId = "";
            //   accountDate.secretFileName = "";
          } else if (this.accountForm.accountType == 4) {
            if (this.fileName == "") {
              this.loading = false;
              this.$Message.error(this.$t("permission_configuration_management.account.pleaseUploadAttachment"));
              return;
            }
            if (this.fileList.length > 1) {
              this.loading = false;
              this.$Message.error(this.$t("permission_configuration_management.account.onlyOneAttachment"));
              return;
            }
            accountDate.areaType = 2;
            accountDate.projectId = this.accountForm.projectId;
            accountDate.secretFileName = this.fileName;
            accountDate.roleArn = "";
            accountDate.externalId = "";
            accountDate.roleSessionName = "";
            accountDate.subscriptionId = "";
            accountDate.subscriptionName = "";
          }

          if (this.accountForm.id) {
            accountDate.id = this.accountForm.id;
            this.$api.account.updateAccount(accountDate).then(res => {
              setTimeout(() => {
                this.$refs[name].resetFields();
                tableAccounts.methods.showAll();
                this.$Message.success(this.$t("common.editSuccess"));
                this.fileName = "";
                this.addEditModal = false;
              }, 1000);
            }).finally(() => {
              this.loading = false;
            });
          } else {
            this.$api.account.createAccount(accountDate).then(res => {
              setTimeout(() => {
                this.$refs[name].resetFields();
                tableAccounts.methods.showAll();
                this.$Message.success(this.$t("common.addSuccess"));
                this.fileName = "";
                this.addEditModal = false;
              }, 1000);
            }).finally(() => {
              this.loading = false;
            });
          }
        } else {
          if (this.accountForm.id > 0) {
            this.$Message.error(this.$t("common.editFail"));
          } else {
            this.$Message.error(this.$t("common.addFail"));
          }
          this.loading = false;
        }
      });
    },
    // 取消
    cancel(name) {
      this.addEditModal = false;
      if (this.fileName != "") {
        this.$api.account
          .deleteSecretFile("fileName", this.fileName)
          .then(res => {
            this.fileName = "";
          });
      }
      this.$nextTick(() => {
        this.$refs[name].resetFields();
      });
    }
  }
};
</script>
<style scoped>
.addPolicies-main {
  width: 96%;
  min-height: 100px;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  padding: 0 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/account/AddOrUpdateAccounts.vue